import AddressIcon from "src/assets/all-icons/address-icon.jsx";

import './styles/OrderShippingCard.css';

export default function OrderShippingCard({ shippingData }) {
  return (
    <>
      <div className="order-shipping-card__container">
        <AddressIcon className="order-shipping-card__icon"/>

        <div className="order-shipping-card__info">
          <span className="order-shipping-card__main-text font-size-medium" style={{ fontWeight: "600" }}>
            {shippingData.address_name} {shippingData.address_surname}
          </span>

          <span className="order-shipping-card__main-text font-size-medium">
            {shippingData.address_phone.address_phone_prefix} {shippingData.address_phone.address_phone_number}
          </span>

          <span className="order-shipping-card__text font-size-medium">
            {shippingData.address_street}
          </span>

          <span className="order-shipping-card__text font-size-medium">
            {shippingData.address_city}{", "}
            {shippingData.address_region}{", "}
            {shippingData.address_country}{", "}
            {shippingData.address_zip_code}
          </span>
        </div>
      </div>
    </>
  );
}
